import { Box, Checkbox, FormControlLabel, Paper } from '@mui/material';

export type FilterOption = {
  value: string;
  name: string;
};

type OptionFilterPanelProps = {
  options: FilterOption[];
  selected: Record<string, boolean>;
  onChange: (newSelected: Record<string, boolean>) => void;
};

const OptionFilterPanel: React.FC<OptionFilterPanelProps> = ({ options, selected, onChange }) => {
  const toggle = (value: string) => {
    const next = { ...selected };
    if (next[value]) {
      delete next[value];
    } else {
      next[value] = true;
    }
    onChange(next);
  };

  return (
    <Paper sx={{ pl: 2, pt: 1, pb: 1, minWidth: 200 }}>
      {options.map(option => (
        <Box key={option.value}>
          <FormControlLabel
            label={option.name}
            control={
              <Checkbox
                size="small"
                checked={!!selected[option.value]}
                onChange={() => toggle(option.value)}
                // Checkboxes toggle on Space natively; also honor Enter, which
                // keyboard users reasonably expect when navigating the filters.
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    toggle(option.value);
                  }
                }}
              />
            }
          />
        </Box>
      ))}
    </Paper>
  );
};

export default OptionFilterPanel;
